import React, { Component } from 'react';
import { Box, styled, css } from '@goodrx/matisse';
import { User } from '@goodrx/heydoctor-sdk';
import { MessageTypes } from '@goodrx/heydoctor-core';
import { connect } from 'app/lib/synaptik';
import { withRouter } from 'react-router-dom';
import { mediaMinWidth } from 'app/lib/utils';
import { AppContext } from 'app/config/AppContext';

import MessageList from './message-list';
import ChatInput from './chat-input';

const MessageListWrapper = styled.div(
  (p) => css`
    flex: 1;
    overflow-y: auto;
    position: relative;
    max-height: 100%;
    padding: ${p.theme.space[3]}px;

    ${mediaMinWidth({
      md: css`
        padding: ${p.theme.space[3]}px ${p.theme.space[5]}px;
      `,
    })}
  `
);

const ChatBox = styled(Box)`
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow-y: hidden;
  height: 100%;
`;

interface ChatProps {
  send?: any;
  sendingMessage?: boolean;
  history?: any;
  toggleChat?: any;
  isChatOpen?: any;
  user?: User;
  reauthenticate?: any; // should be VoidFunction but would require I pass these props from chatDrawer
}

// @ts-ignore
@withRouter
@connect(
  ({
    chat: {
      send,
      toggleChat,
      state: { sending: sendingMessage, isChatOpen },
    },
    user: {
      reauthenticate,
      state: { profile },
    },
  }) => ({
    send,
    sendingMessage,
    toggleChat,
    isChatOpen,
    reauthenticate,
    user: profile,
  })
)
export default class Chat extends Component<ChatProps, any> {
  state = {
    message: '',
  };

  static contextType = AppContext;

  handleActionClick = (message: any) => {
    const { history, toggleChat, isChatOpen } = this.props;
    const { isGold } = this.context;

    const persistMessageDrawerTypes = [MessageTypes.PHONE_CALL_BACK];
    if (isChatOpen && !persistMessageDrawerTypes.includes(message.type)) {
      toggleChat();
    }

    switch (message.type) {
      case MessageTypes.PRESCRIPTION:
        if (isGold) {
          window.open(`goodrx://gth_prescription?prescription_id=${message.visitPrescriptionId}`);
        } else {
          history.push(`/account/orders/${message.visitPrescriptionId}`);
        }
        break;
      case MessageTypes.PHONE_CALL_BACK:
        this.props.send('Continue my visit.');
        break;
      case MessageTypes.START_VISIT:
        if (isGold) {
          window.open('https://gx9e.app.link/425P6qsvIab');
        }
        break;
      default:
        break;
    }
  };

  sendMessage = async () => {
    const { isGold } = this.context;
    const { user, send, reauthenticate } = this.props;
    if (isGold && user === null) {
      await reauthenticate();
    }
    await send(this.state.message);
    this.setState({ message: '' });
  };

  onChange = (_field: any, message: any) => this.setState({ message });

  render() {
    const { message } = this.state;
    const { sendingMessage } = this.props;

    return (
      <ChatBox data-testid="chat">
        <MessageListWrapper>
          <MessageList onActionClick={this.handleActionClick} />
        </MessageListWrapper>

        <ChatInput
          message={message}
          sendingMessage={sendingMessage}
          onChange={this.onChange}
          onSubmit={this.sendMessage}
        />
      </ChatBox>
    );
  }
}
